import React, { Suspense, lazy } from "react";
const Layout = lazy(() => import("antd").then(m => ({ default: m.Layout })));
//import MainHeader from "./mainHeader/index";
import { useLocation } from "react-router-dom";
const HomePage = lazy(() => import("../../homePage"));
const SearchBar = lazy(() => import("../../../components/searchbar/SearchBar"));
import { useSelector } from "react-redux";
import UserLoader from "../../../components/atoms/userLoader";
const HomePageHeader = lazy(() => import("../../homePage/homePageHeader"));
const MobileFooter = lazy(() => import("../../homePage/mobileFooter"));

const UserRouteAll = lazy(() =>
  import("../../../routes").then((module) => ({ default: module.UserRouteAll }))
);

const UserRoute = lazy(() =>
  import("../../../routes").then((module) => ({ default: module.UserRoute }))
);

// eslint-disable-next-line no-unused-vars
function NewUserLayout() {
  const { pathname } = useLocation();

  const searchCardFocus = useSelector(
    (state) => {
      return state?.searchCardData?.searchCardFocus;
    }
  );

  const renderContent = () => {
    switch (true) {
      case pathname.includes("/checkout") || pathname.includes("/hotel/"):
        return (
          <Suspense fallback={<UserLoader />}>
            <UserRouteAll />
          </Suspense>
        );

      case searchCardFocus:
        return <Suspense fallback={<UserLoader />}><SearchBar /></Suspense>;

      case pathname.includes("hotels/search"):
        return (
          <Layout style={{ backgroundColor: "#fff" }}>
            <HomePageHeader />
            <Suspense fallback={<UserLoader />}>
              <UserRoute />
            </Suspense>
          </Layout>
        );

      case pathname === "/":
        return <Suspense fallback={<UserLoader />}><HomePage /></Suspense>;

      default:
        return (
          <>
            <HomePageHeader />
            <Suspense fallback={<UserLoader />}>
              <UserRoute />
            </Suspense>
          </>
        );
    }
  };

  return (
    <div className="bg-white">
      <Suspense fallback={<UserLoader />}>
        {renderContent()}
        <MobileFooter />
      </Suspense>
    </div>
  );
}

export default NewUserLayout;